import React from 'react';
import { connect } from 'react-redux';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelTop from './rightPanelTop';
import CenterPanelView from './centerPanelView';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { updateAfterCallDetail } from '../../../../actions/waitingArea.js';
import { showWaitingAreaAfterCallsModal } from '../../../../actions/modal.js';

export default function AfterCallWaitingArea(props) {
  let centerPanel = {};
  let title = APP.LANGUAGE.WaitingAreaAfterCalls.TitleUpdateAndView;
  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  var updatingWaitingAreaName = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';
  let subtitle = updatingWaitingAreaName;

  let rightPanel = (
    <RightPanelTop
      waitingArea={props.waitingArea}
      afterCallsForm={props.afterCallsForm}
      updateOrView={props.updateOrView}
    />
  );

  if (props.updateOrView == 'update') {
    centerPanel = (
      <CenterPanelUpdate
        afterCallsForm={props.afterCallsForm}
        isAdmin={props.isAdmin}
        originalAfterCallForm={props.originalAfterCallForm}
        waitingArea={props.waitingArea}
      />
    );
  } else {
    centerPanel = <CenterPanelView afterCallsForm={props.afterCallsForm} waitingArea={props.waitingArea} />;
  }

  return (
    <Modal
      show={props.showAfterCallsModal}
      hideWhenClickAway={false}
      className={props.updateOrInsert + ' waiting-area-after-call'}
    >
      <PopupHeader helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpAfterCalls} title={title} subtitle={subtitle} />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom isAdmin={props.isAdmin} />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              {rightPanel}
              <RightPanelBottom isAdmin={props.isAdmin} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
